// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== SelfDetail.css ====================
   All classes prefixed sd- to avoid global collisions.
   Shared st- toggle/switch classes come from SettingsGridLayout.css
   ======================================================== */

/* ── Root wrapper ──────────────────────────────────────────────────────── */
.sd-root {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  /* ── Toast ─────────────────────────────────────────────────────────────── */
  .sd-toast {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 13px 18px;
    border-radius: 9px;
    font-size: 13.5px;
    font-weight: 500;
    margin-bottom: 24px;
    animation: sd-toastSlide 0.22s ease;
    box-sizing: border-box;
  }
  
  @keyframes sd-toastSlide {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0);    }
  }
  
  .sd-toast--success {
    background: rgba(76, 175, 80, 0.14);
    border: 1px solid rgba(76, 175, 80, 0.35);
    color: #81c784;
  }
  
  .sd-toast--warning {
    background: rgba(255, 152, 0, 0.12);
    border: 1px solid rgba(255, 152, 0, 0.35);
    color: #ffb74d;
  }
  
  .sd-toast-close {
    background: transparent;
    border: none;
    color: inherit;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    opacity: 0.7;
    flex-shrink: 0;
  }
  
  .sd-toast-close:hover { opacity: 1; }
  
  /* ── Section wrapper ───────────────────────────────────────────────────── */
  .sd-section {
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 14px;
    padding: 28px 30px;
    margin-bottom: 28px;
    background: rgba(255, 255, 255, 0.02);
    box-sizing: border-box;
    color: white;
  }
  
  .sd-section--private {
    border-color: rgba(244, 67, 54, 0.18);
    background: rgba(244, 67, 54, 0.03);
  }
  
  /* ── Section header ────────────────────────────────────────────────────── */
  .sd-section-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 24px;
    padding-bottom: 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  }
  
  .sd-section--private .sd-section-header {
    border-bottom-color: rgba(244, 67, 54, 0.12);
  }
  
  .sd-section-header-left {
    display: flex;
    align-items: flex-start;
    gap: 14px;
  }
  
  .sd-section-icon {
    font-size: 1.6rem;
    flex-shrink: 0;
    margin-top: 2px;
    color: white;
  }
  
  .sd-section-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 4px 0;
    padding: 0;
  }
  
  .sd-section-subtitle {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.42);
    margin: 0;
    padding: 0;
    line-height: 1.6;
    max-width: 500px;
  }
  
  .sd-section-badge {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 700;
    padding: 5px 11px;
    border-radius: 20px;
    white-space: nowrap;
    background: none;
    color: white;
    border: 1px solid gray;
    letter-spacing: 0.04em;
  }
  
  .sd-section--private .sd-section-badge {
    background: none;
    color: white;
    border-color: gray;
  }
  
  /* ── Generic field row ─────────────────────────────────────────────────── */
  .sd-field-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 13px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    box-sizing: border-box;
  }
  
  .sd-field-row:last-of-type   { border-bottom: none; }
  
  .sd-field-row--private {
    border-radius: 8px;
    padding: 13px 14px;
    margin-bottom: 6px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(255, 255, 255, 0.02);
    transition: background 0.2s ease, border-color 0.2s ease;
  }
  
  .sd-field-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
    min-width: 0;
  }
  
  .sd-field-icon {
    font-size: 1.2rem;
    flex-shrink: 0;
    width: 28px;
    text-align: center;
  }
  
  .sd-field-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  
  .sd-field-label {
    font-size: 13.5px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.82);
  }
  
  .sd-field-sublabel {
    font-size: 11.5px;
    color: rgba(255, 255, 255, 0.38);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .sd-private-badge {
    font-size: 10px;
    font-weight: 700;
    color: rgba(244, 67, 54, 0.75);
    letter-spacing: 0.04em;
    margin-top: 2px;
  }
  
  .sd-field-right {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }
  
  /* ── Visibility tags ───────────────────────────────────────────────────── */
  .sd-visibility-tag {
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 20px;
    white-space: nowrap;
    letter-spacing: 0.03em;
  }
  
  .sd-vis--public {
    background: rgba(76, 175, 80, 0.15);
    color: #81c784;
    border: 1px solid rgba(76, 175, 80, 0.3);
  }
  
  .sd-vis--hidden {
    background: rgba(120, 120, 120, 0.15);
    color: rgba(255, 255, 255, 0.38);
    border: 1px solid rgba(255, 255, 255, 0.10);
  }
  
  .sd-vis--private, .sd-vis--exposed {
    background: none;
    color: white;
    border: 1px solid gray;
  }
    
  /* ── Danger slider override ────────────────────────────────────────────── */
  .st-switch input:checked + .st-slider--danger {
    background: #f44336 !important;
  }
  
  /* ── Image uploader ────────────────────────────────────────────────────── */
  .sd-image-block {
    display: flex;
    align-items: flex-start;
    gap: 32px;
    padding: 16px 0 20px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    margin-bottom: 4px;
  }
  
  .sd-image-block-left  { flex-shrink: 0; display: flex; flex-direction: column; gap: 8px; }
  .sd-image-block-right { flex: 1 1; }
  
  .sd-image-uploader {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .sd-image-preview-wrap {
    position: relative;
    width: 90px;
    height: 90px;
  }
  
  .sd-image-preview,
  .sd-image-placeholder {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .sd-image-change-btn {
    position: absolute;
    bottom: -2px;
    right: -30px;
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.75);
    font-size: 11px;
    font-weight: 600;
    padding: 4px 9px;
    border-radius: 20px;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.18s ease;
  }
  
  .sd-image-hint {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.28);
    margin: 0;
    padding: 0;
  }
  
  /* ── Editable field block (name / location) ────────────────────────────── */
  .sd-editable-field-block {
    padding: 16px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  
  .sd-editable-field-inputs { width: 100%; max-width: 420px; }
  
  /* ── Stats block ───────────────────────────────────────────────────────── */
  .sd-stats-block {
    padding: 16px 0 0 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  .sd-stats-grid {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
  }
  
  .sd-stat-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 10px;
    padding: 14px 18px;
    min-width: 90px;
  }
  
  .sd-stat-icon  { font-size: 1.4rem; }
  
  .sd-stat-input {
    width: 70px !important;
    max-width: 70px !important;
    text-align: center;
    padding: 7px 8px !important;
    font-size: 15px !important;
    font-weight: 700 !important;
  }
  
  .sd-stat-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.40);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 600;
  }
  
  .sd-stats-toggles { display: flex; flex-direction: column; gap: 0; }
  
  /* ── Private warning banner ────────────────────────────────────────────── */
  .sd-private-warning {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: rgba(255, 152, 0, 0.08);
    border: 1px solid rgba(255, 152, 0, 0.22);
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 20px;
  }
  
  .sd-warning-icon { font-size: 1.2rem; flex-shrink: 0; margin-top: 1px; }
  
  .sd-warning-text {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.62);
    margin: 0;
    padding: 0;
    line-height: 1.65;
  }
  
  /* ── Exposure summary banner ───────────────────────────────────────────── */
  .sd-exposure-summary {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: rgba(244, 67, 54, 0.10);
    border: 1px solid rgba(244, 67, 54, 0.28);
    border-radius: 10px;
    padding: 16px 18px;
    margin-top: 18px;
  }
  
  .sd-exposure-summary-icon  { font-size: 1.3rem; flex-shrink: 0; }
  
  .sd-exposure-summary-title {
    font-size: 13.5px;
    font-weight: 700;
    color: #ef9a9a;
    margin: 0 0 4px 0;
    padding: 0;
  }
  
  .sd-exposure-summary-text {
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.50);
    margin: 0;
    padding: 0;
    line-height: 1.55;
  }
  
  /* ── Action bar ────────────────────────────────────────────────────────── */
  .sd-action-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 28px;
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    margin-top: 8px;
  }
  
  .sd-submit-btn,
  .sd-cancel-btn {
    padding: 12px 30px;
    border-radius: 9px;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    border: none;
  }
  
  .sd-submit-btn {
    background: rgba(36,36,45,0.2);
    border: "1px solid gray";
    color: #fff;
  }
  
  .sd-submit-btn:hover {
    transform: translateY(-1px);
  }
  
  .sd-cancel-btn {
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.65);
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
  
  .sd-cancel-btn:hover {
    background: rgba(255, 255, 255, 0.10);
    color: rgba(255, 255, 255, 0.90);
  }
  
  /* ── Responsive ────────────────────────────────────────────────────────── */
  @media (max-width: 768px) {
    .sd-section            { padding: 20px 16px; }
    .sd-image-block        { flex-direction: column; gap: 20px; }
    .sd-image-block-right  { width: 100%; }
    .sd-stats-grid         { gap: 10px; }
    .sd-stat-card          { min-width: 76px; padding: 12px 12px; }
    .sd-action-bar         { flex-direction: column-reverse; align-items: stretch; }
    .sd-submit-btn,
    .sd-cancel-btn         { width: 100%; text-align: center; }
    .sd-section-header     { flex-direction: column; gap: 10px; }
  }
  
  @media (max-width: 480px) {
    .sd-section     { padding: 16px 12px; }
    .sd-stats-grid  { grid-template-columns: repeat(3, 1fr); display: grid; }
    .sd-stat-card   { min-width: unset; }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/SelfDetail.css"],"names":[],"mappings":"AAAA;;;6DAG6D;;AAE7D,6EAA6E;AAC7E;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,mCAAmC;IACnC,sBAAsB;EACxB;;EAEA;IACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,KAAK;EAClD;;EAEA;IACE,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,UAAU;IACV,cAAc;IACd,YAAY;IACZ,cAAc;EAChB;;EAEA,wBAAwB,UAAU,EAAE;;EAEpC,6EAA6E;EAC7E;IACE,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,mCAAmC;EACrC;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,kDAAkD;EACpD;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,kDAAkD;IAClD,sBAAsB;EACxB;;EAEA,+BAA+B,mBAAmB,EAAE;;EAEpD;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,wDAAwD;EAC1D;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;EAChB;;EAEA,6EAA6E;EAC7E;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;IACnC,cAAc;IACd,wCAAwC;EAC1C;;EAEA;IACE,qCAAqC;IACrC,gCAAgC;IAChC,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;;EAEA,6EAA6E;EAC7E;IACE,8BAA8B;EAChC;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,kDAAkD;IAClD,kBAAkB;EACpB;;EAEA,wBAAwB,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;EACzF,wBAAwB,SAAO,EAAE;;EAEjC;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;IAC3C,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,2CAA2C;IAC3C,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;EACZ;;EAEA,6EAA6E;EAC7E;IACE,eAAe;IACf,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,4BAA4B,WAAW,EAAE,gBAAgB,EAAE;;EAE3D,6EAA6E;EAC7E;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,iBAAiB,iBAAiB,EAAE;;EAEpC;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;;EAEnE,6EAA6E;EAC7E;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,mBAAmB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;EAEvE;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,6BAA6B,iBAAiB,EAAE,cAAc,EAAE;;EAEhE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,+CAA+C;IAC/C,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,8EAA8E;IAC9E,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;IACrC,gCAAgC;IAChC,2CAA2C;EAC7C;;EAEA;IACE,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA,6EAA6E;EAC7E;IACE,yBAAyB,kBAAkB,EAAE;IAC7C,yBAAyB,sBAAsB,EAAE,SAAS,EAAE;IAC5D,yBAAyB,WAAW,EAAE;IACtC,yBAAyB,SAAS,EAAE;IACpC,yBAAyB,eAAe,EAAE,kBAAkB,EAAE;IAC9D,yBAAyB,8BAA8B,EAAE,oBAAoB,EAAE;IAC/E;6BACyB,WAAW,EAAE,kBAAkB,EAAE;IAC1D,yBAAyB,sBAAsB,EAAE,SAAS,EAAE;EAC9D;;EAEA;IACE,kBAAkB,kBAAkB,EAAE;IACtC,kBAAkB,qCAAqC,EAAE,aAAa,EAAE;IACxE,kBAAkB,gBAAgB,EAAE;EACtC","sourcesContent":["/* ==================== SelfDetail.css ====================\n   All classes prefixed sd- to avoid global collisions.\n   Shared st- toggle/switch classes come from SettingsGridLayout.css\n   ======================================================== */\n\n/* ── Root wrapper ──────────────────────────────────────────────────────── */\n.sd-root {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  /* ── Toast ─────────────────────────────────────────────────────────────── */\n  .sd-toast {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 13px 18px;\n    border-radius: 9px;\n    font-size: 13.5px;\n    font-weight: 500;\n    margin-bottom: 24px;\n    animation: sd-toastSlide 0.22s ease;\n    box-sizing: border-box;\n  }\n  \n  @keyframes sd-toastSlide {\n    from { opacity: 0; transform: translateY(-8px); }\n    to   { opacity: 1; transform: translateY(0);    }\n  }\n  \n  .sd-toast--success {\n    background: rgba(76, 175, 80, 0.14);\n    border: 1px solid rgba(76, 175, 80, 0.35);\n    color: #81c784;\n  }\n  \n  .sd-toast--warning {\n    background: rgba(255, 152, 0, 0.12);\n    border: 1px solid rgba(255, 152, 0, 0.35);\n    color: #ffb74d;\n  }\n  \n  .sd-toast-close {\n    background: transparent;\n    border: none;\n    color: inherit;\n    font-size: 18px;\n    cursor: pointer;\n    padding: 0;\n    line-height: 1;\n    opacity: 0.7;\n    flex-shrink: 0;\n  }\n  \n  .sd-toast-close:hover { opacity: 1; }\n  \n  /* ── Section wrapper ───────────────────────────────────────────────────── */\n  .sd-section {\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    border-radius: 14px;\n    padding: 28px 30px;\n    margin-bottom: 28px;\n    background: rgba(255, 255, 255, 0.02);\n    box-sizing: border-box;\n    color: white;\n  }\n  \n  .sd-section--private {\n    border-color: rgba(244, 67, 54, 0.18);\n    background: rgba(244, 67, 54, 0.03);\n  }\n  \n  /* ── Section header ────────────────────────────────────────────────────── */\n  .sd-section-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 14px;\n    margin-bottom: 24px;\n    padding-bottom: 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  }\n  \n  .sd-section--private .sd-section-header {\n    border-bottom-color: rgba(244, 67, 54, 0.12);\n  }\n  \n  .sd-section-header-left {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n  }\n  \n  .sd-section-icon {\n    font-size: 1.6rem;\n    flex-shrink: 0;\n    margin-top: 2px;\n    color: white;\n  }\n  \n  .sd-section-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0 0 4px 0;\n    padding: 0;\n  }\n  \n  .sd-section-subtitle {\n    font-size: 12.5px;\n    color: rgba(255, 255, 255, 0.42);\n    margin: 0;\n    padding: 0;\n    line-height: 1.6;\n    max-width: 500px;\n  }\n  \n  .sd-section-badge {\n    flex-shrink: 0;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 5px 11px;\n    border-radius: 20px;\n    white-space: nowrap;\n    background: none;\n    color: white;\n    border: 1px solid gray;\n    letter-spacing: 0.04em;\n  }\n  \n  .sd-section--private .sd-section-badge {\n    background: none;\n    color: white;\n    border-color: gray;\n  }\n  \n  /* ── Generic field row ─────────────────────────────────────────────────── */\n  .sd-field-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 13px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    box-sizing: border-box;\n  }\n  \n  .sd-field-row:last-of-type   { border-bottom: none; }\n  \n  .sd-field-row--private {\n    border-radius: 8px;\n    padding: 13px 14px;\n    margin-bottom: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(255, 255, 255, 0.02);\n    transition: background 0.2s ease, border-color 0.2s ease;\n  }\n  \n  .sd-field-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n    min-width: 0;\n  }\n  \n  .sd-field-icon {\n    font-size: 1.2rem;\n    flex-shrink: 0;\n    width: 28px;\n    text-align: center;\n  }\n  \n  .sd-field-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n  \n  .sd-field-label {\n    font-size: 13.5px;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.82);\n  }\n  \n  .sd-field-sublabel {\n    font-size: 11.5px;\n    color: rgba(255, 255, 255, 0.38);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .sd-private-badge {\n    font-size: 10px;\n    font-weight: 700;\n    color: rgba(244, 67, 54, 0.75);\n    letter-spacing: 0.04em;\n    margin-top: 2px;\n  }\n  \n  .sd-field-right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-shrink: 0;\n  }\n  \n  /* ── Visibility tags ───────────────────────────────────────────────────── */\n  .sd-visibility-tag {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 4px 10px;\n    border-radius: 20px;\n    white-space: nowrap;\n    letter-spacing: 0.03em;\n  }\n  \n  .sd-vis--public {\n    background: rgba(76, 175, 80, 0.15);\n    color: #81c784;\n    border: 1px solid rgba(76, 175, 80, 0.3);\n  }\n  \n  .sd-vis--hidden {\n    background: rgba(120, 120, 120, 0.15);\n    color: rgba(255, 255, 255, 0.38);\n    border: 1px solid rgba(255, 255, 255, 0.10);\n  }\n  \n  .sd-vis--private, .sd-vis--exposed {\n    background: none;\n    color: white;\n    border: 1px solid gray;\n  }\n    \n  /* ── Danger slider override ────────────────────────────────────────────── */\n  .st-switch input:checked + .st-slider--danger {\n    background: #f44336 !important;\n  }\n  \n  /* ── Image uploader ────────────────────────────────────────────────────── */\n  .sd-image-block {\n    display: flex;\n    align-items: flex-start;\n    gap: 32px;\n    padding: 16px 0 20px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    margin-bottom: 4px;\n  }\n  \n  .sd-image-block-left  { flex-shrink: 0; display: flex; flex-direction: column; gap: 8px; }\n  .sd-image-block-right { flex: 1; }\n  \n  .sd-image-uploader {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .sd-image-preview-wrap {\n    position: relative;\n    width: 90px;\n    height: 90px;\n  }\n  \n  .sd-image-preview,\n  .sd-image-placeholder {\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid rgba(255, 255, 255, 0.12);\n    background: rgba(255, 255, 255, 0.05);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .sd-image-change-btn {\n    position: absolute;\n    bottom: -2px;\n    right: -30px;\n    background: none;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    color: rgba(255, 255, 255, 0.75);\n    font-size: 11px;\n    font-weight: 600;\n    padding: 4px 9px;\n    border-radius: 20px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.18s ease;\n  }\n  \n  .sd-image-hint {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.28);\n    margin: 0;\n    padding: 0;\n  }\n  \n  /* ── Editable field block (name / location) ────────────────────────────── */\n  .sd-editable-field-block {\n    padding: 16px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n  \n  .sd-editable-field-inputs { width: 100%; max-width: 420px; }\n  \n  /* ── Stats block ───────────────────────────────────────────────────────── */\n  .sd-stats-block {\n    padding: 16px 0 0 0;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .sd-stats-grid {\n    display: flex;\n    gap: 14px;\n    flex-wrap: wrap;\n  }\n  \n  .sd-stat-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    border-radius: 10px;\n    padding: 14px 18px;\n    min-width: 90px;\n  }\n  \n  .sd-stat-icon  { font-size: 1.4rem; }\n  \n  .sd-stat-input {\n    width: 70px !important;\n    max-width: 70px !important;\n    text-align: center;\n    padding: 7px 8px !important;\n    font-size: 15px !important;\n    font-weight: 700 !important;\n  }\n  \n  .sd-stat-label {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.40);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    font-weight: 600;\n  }\n  \n  .sd-stats-toggles { display: flex; flex-direction: column; gap: 0; }\n  \n  /* ── Private warning banner ────────────────────────────────────────────── */\n  .sd-private-warning {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    background: rgba(255, 152, 0, 0.08);\n    border: 1px solid rgba(255, 152, 0, 0.22);\n    border-radius: 10px;\n    padding: 14px 16px;\n    margin-bottom: 20px;\n  }\n  \n  .sd-warning-icon { font-size: 1.2rem; flex-shrink: 0; margin-top: 1px; }\n  \n  .sd-warning-text {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.62);\n    margin: 0;\n    padding: 0;\n    line-height: 1.65;\n  }\n  \n  /* ── Exposure summary banner ───────────────────────────────────────────── */\n  .sd-exposure-summary {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    background: rgba(244, 67, 54, 0.10);\n    border: 1px solid rgba(244, 67, 54, 0.28);\n    border-radius: 10px;\n    padding: 16px 18px;\n    margin-top: 18px;\n  }\n  \n  .sd-exposure-summary-icon  { font-size: 1.3rem; flex-shrink: 0; }\n  \n  .sd-exposure-summary-title {\n    font-size: 13.5px;\n    font-weight: 700;\n    color: #ef9a9a;\n    margin: 0 0 4px 0;\n    padding: 0;\n  }\n  \n  .sd-exposure-summary-text {\n    font-size: 12.5px;\n    color: rgba(255, 255, 255, 0.50);\n    margin: 0;\n    padding: 0;\n    line-height: 1.55;\n  }\n  \n  /* ── Action bar ────────────────────────────────────────────────────────── */\n  .sd-action-bar {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    padding-top: 28px;\n    border-top: 1px solid rgba(255, 255, 255, 0.07);\n    margin-top: 8px;\n  }\n  \n  .sd-submit-btn,\n  .sd-cancel-btn {\n    padding: 12px 30px;\n    border-radius: 9px;\n    font-size: 13.5px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n    border: none;\n  }\n  \n  .sd-submit-btn {\n    background: rgba(36,36,45,0.2);\n    border: \"1px solid gray\";\n    color: #fff;\n  }\n  \n  .sd-submit-btn:hover {\n    transform: translateY(-1px);\n  }\n  \n  .sd-cancel-btn {\n    background: rgba(255, 255, 255, 0.06);\n    color: rgba(255, 255, 255, 0.65);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n  }\n  \n  .sd-cancel-btn:hover {\n    background: rgba(255, 255, 255, 0.10);\n    color: rgba(255, 255, 255, 0.90);\n  }\n  \n  /* ── Responsive ────────────────────────────────────────────────────────── */\n  @media (max-width: 768px) {\n    .sd-section            { padding: 20px 16px; }\n    .sd-image-block        { flex-direction: column; gap: 20px; }\n    .sd-image-block-right  { width: 100%; }\n    .sd-stats-grid         { gap: 10px; }\n    .sd-stat-card          { min-width: 76px; padding: 12px 12px; }\n    .sd-action-bar         { flex-direction: column-reverse; align-items: stretch; }\n    .sd-submit-btn,\n    .sd-cancel-btn         { width: 100%; text-align: center; }\n    .sd-section-header     { flex-direction: column; gap: 10px; }\n  }\n  \n  @media (max-width: 480px) {\n    .sd-section     { padding: 16px 12px; }\n    .sd-stats-grid  { grid-template-columns: repeat(3, 1fr); display: grid; }\n    .sd-stat-card   { min-width: unset; }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
